<template>
  <div class="wg-row tickets-type-menu" style="height: calc(100vh - 60px)">
    <!-- Sub menu con scelta categorie -->
    <world-sub-menu :selected="pageId" :list="list" @changePage="changePage">
      <template v-slot:content>
        <!-- Ticket type details -->
        <ticket-type v-if="pageId === 'ticketType'"></ticket-type>
        <!-- Ticket type events -->
        <ticket-type-events
          v-if="pageId === 'ticketTypeEvents'"
        ></ticket-type-events>
      </template>
    </world-sub-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
import WorldSubMenu from "../../../../world/spa/components/WorldSubMenu.vue";
import TicketType from "../components/TicketType.vue";
import TicketTypeEvents from "../components/TicketTypeEvents.vue";

export default {
  data() {
    return {
      loading: false,
      pageId: "ticketType",
    };
  },
  components: {
    WorldSubMenu,
    TicketType,
    TicketTypeEvents,
  },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
      workSelected: (state) => state.workSelected,
      windowWidth: (state) => state.windowWidth,
      windowHeight: (state) => state.windowHeight,
    }),
    list() {
      const list = [];
      list.push({
        id: "ticketsList",
        img: this.$anm22.icons.getWorldIcon("ticket"),
        label: this.$anm22.strLang(this.lang, "Tickets", "Biglietti"),
        routeTo: "/tickets",
      });
      list.push({
        id: "ticketTypes",
        img: this.$anm22.icons.getWorldIcon("menuSettings"),
        label: this.$anm22.strLang(
          this.lang,
          "Ticket types",
          "Tipologie biglietti"
        ),
        routeTo: "/tickets/types",
      });
      list.push({
        id: "ticketType",
        img: this.$anm22.icons.getWorldIcon("ticket"),
        label: this.$anm22.strLang(this.lang, "Details", "Dettagli"),
      });
      list.push({
        id: "ticketTypeEvents",
        img: this.$anm22.icons.getWorldIcon("event"),
        label: this.$anm22.strLang(this.lang, "Events", "Eventi"),
      });
      list.push({
        id: "ticketAnalytics",
        img: this.$anm22.icons.getWorldIcon("menuAnalytics"),
        label: this.$anm22.strLang(
          this.lang,
          "Analytics",
          "Statistiche"
        ),
        routeTo: "/tickets/analytics",
      });
      list.push({
        id: "ticketBoxes",
        img: this.$anm22.icons.getWorldIcon("email"),
        label: this.$anm22.strLang(
          this.lang,
          "Boxes",
          "Buste"
        ),
        routeTo: "/tickets/boxes",
      });
      return list;
    },
  },
  methods: {
    changePage(elem) {
      if (typeof elem == "string") {
        elem = this.list.find((l) => l.id === elem);
      }
      if (elem.routeTo) {
        this.$router.push(elem.routeTo);
      } else {
        this.pageId = elem.id;
      }
    },
  },
  created() {
    document.title =
      this.$anm22.strLang(this.lang, "Tickets", "Tickets") +
      " | ANM22 Calendar";
    this.$store.dispatch("works/load", this.$vlf("works"));
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, "Tickets", "Tickets")
    );
    this.$Progress.finish();
  },
};
</script>

<style lang="scss" scoped>
.qrcode {
  display: block;
  margin: 0 auto;
  padding: 10px;
  width: 150px;
  height: 150px;
}
</style>

<style lang="scss">
.ticket-menu .sub-menu-li .item-icon {
  opacity: 0.6;
}
</style>
